import { CSSProperties } from 'react'

const overlay: CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
  backdropFilter: 'blur(2px)',
}

const box: CSSProperties = {
  background: '#fff', borderRadius: 12, padding: '28px 36px',
  display: 'flex', alignItems: 'center', gap: 14,
  boxShadow: '0 8px 30px rgba(0,0,0,0.15)',
}

const spinner: CSSProperties = {
  width: 22, height: 22, border: '3px solid #e2e8f0',
  borderTopColor: '#2563eb', borderRadius: '50%',
  animation: 'po-spin 0.6s linear infinite',
}

export default function ProcessingOverlay({ message = 'Processing...' }: { message?: string }) {
  return (
    <>
      <style>{`@keyframes po-spin { to { transform: rotate(360deg) } }`}</style>
      <div style={overlay}>
        <div style={box}>
          <div style={spinner} />
          <span style={{ fontSize: 14, fontWeight: 600, color: '#1e293b' }}>{message}</span>
        </div>
      </div>
    </>
  )
}
